module.exports = __webpack_public_path__ + "img/f93de6d.png";